module.exports = __webpack_public_path__ + "media/images/front/centres/factory_alger-542ad15c8c6efc945d799b86f7079f3b.jpg";